module.exports = __webpack_public_path__ + "assets/img/folder.09c6fff6.svg";